import Mafuba from 'mafuba'

export default new Mafuba({
  launches: [],
  latitude: 0,
  longitude: 0
})
